import { useEffect } from "react";

const SITE_URL = "https://lifelinediagnosticsjsp.com";
const DEFAULT_IMAGE =
  "https://customer-assets-agu9un31.emergentagent.net/job_194d2481-9a39-4faa-a195-11de52f30c81/artifacts/elzv0pey_1786891696373-1ece5ba8-ab46-41b7-9d90-e819eace615e_1.jpg";

function upsertMeta({ name, property, content }) {
  if (!content) return;
  const key = name || property;
  const attr = name ? "name" : "property";
  const nodes = document.querySelectorAll(`meta[${attr}="${key}"]`);
  // Drop any duplicates (e.g., injected by preview infra / third-party scripts)
  for (let i = 1; i < nodes.length; i++) nodes[i].remove();
  let el = nodes[0];
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * SEO — updates document title, meta description, canonical, and
 * Open Graph / Twitter tags per route. Static tags in index.html
 * serve as the crawl-friendly baseline.
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  keywords,
}) {
  useEffect(() => {
    const url = `${SITE_URL}${path === "/" ? "/" : path}`;
    if (title) document.title = title;
    upsertMeta({ name: "description", content: description });
    if (keywords) upsertMeta({ name: "keywords", content: keywords });
    upsertLink("canonical", url);

    // Open Graph
    upsertMeta({ property: "og:title", content: title });
    upsertMeta({ property: "og:description", content: description });
    upsertMeta({ property: "og:url", content: url });
    upsertMeta({ property: "og:image", content: image });
    upsertMeta({ property: "og:type", content: "website" });

    // Twitter
    upsertMeta({ name: "twitter:card", content: "summary_large_image" });
    upsertMeta({ name: "twitter:title", content: title });
    upsertMeta({ name: "twitter:description", content: description });
    upsertMeta({ name: "twitter:image", content: image });
  }, [title, description, path, image, keywords]);

  return null;
}
